export default "__VITE_ASSET__B5JQr7ib__"